import { selectBasketTime, resetTime, selectBasketList, BASKET_TYPES, selectBasketPaymentInProgress, selectBasketCanEdit, selectBasketIsPaid } from 'containers/OrderDetails/basketSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import React, { useEffect, useRef, useState } from 'react'
import { getOrderRedirectPath } from 'utils/redirect'
import Warning from 'containers/Header/WarningPopup'
import { useHistory } from 'react-router-dom'
import TimerContext from './Context'

interface TimerProviderProps {
  children: React.ReactNode
}

const BASIC_TIME = 180
const EXTENDED_TIME = 1800

const TimerProvider: React.FC<TimerProviderProps> = ({ children }) => {
  const paymentsInProgress = useReduxSelector(selectBasketPaymentInProgress)
  const canEdit = useReduxSelector(selectBasketCanEdit)
  const startTime = useReduxSelector(selectBasketTime)
  const isPaid = useReduxSelector(selectBasketIsPaid)
  const list = useReduxSelector(selectBasketList)
  const [time, setTime] = useState(-1)
  const currentList = useRef(list)
  currentList.current = list

  const dispatch = useReduxDispatch()
  const { replace } = useHistory()

  useEffect(() => {
    setTime((startTime && !paymentsInProgress && !isPaid)
      ? (canEdit !== undefined ? EXTENDED_TIME : BASIC_TIME)
      : -1)
  }, [startTime, paymentsInProgress, canEdit, isPaid])

  useEffect(() => {
    if (time > 0) {
      const resetCounter = () => {
        dispatch(resetTime(undefined))
      }
      window.addEventListener('click', resetCounter)
      return () => {
        window.removeEventListener('click', resetCounter)
      }
    }
  }, [dispatch, time])

  useEffect(() => {
    if (time !== -1 && startTime > 0) {
      const interval = setInterval(() => {
        const newTime = (canEdit !== undefined ? EXTENDED_TIME : BASIC_TIME) - ((Date.now() - startTime) / 1000)
        if (newTime < 1) {
          const lastWarehouse = currentList.current.findLast((item: any) => item.type === BASKET_TYPES.rent)
          replace(lastWarehouse?.placeId ? `/mapdetails/${lastWarehouse.placeId}` : getOrderRedirectPath(), { unlock: true })
          setTime(-1)
        } else {
          setTime(newTime)
        }
      }, 1000)
      return () => {
        clearInterval(interval)
      }
    }
  }, [canEdit, replace, startTime, time])

  return (
    <TimerContext.Provider value={time}>
      {(time > 0 && time < 9) && <Warning time={time} />}
      {children}
    </TimerContext.Provider>
  )
}

export default TimerProvider